import {ControlOutlined} from '@ant-design/icons';
import {proposalrequest} from '@mep/pae-commons';
import {Button, Dropdown, Menu, message} from 'antd';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import React, {memo, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useMutation} from 'react-query';

import ProposalRequestStatus from '@/modules/proposalRequest/components/ProposalRequestStatus';

const {PROPOSAL_STATUS_ENUM, PROPOSAL_STATUS} = proposalrequest;

const statusFilter = {
  [PROPOSAL_STATUS.ARCHIVED]: true,
  [PROPOSAL_STATUS.CANCELED]: true,
};

export const createUpdateStatusMany = (service, translation) => {
  const UpdateStatusManyButton = ({items, onChange}) => {
    const {t} = useTranslation(translation);
    const {mutateAsync, isLoading} = useMutation(service);
    const hasItems = !!items;

    const handleChange = useCallback(async ({key}) => {
      if (hasItems) {
        try {
          await mutateAsync({items, status: key});
          onChange && onChange(key);
        } catch (e) {
          message.error('Error');
        }
      }
    }, [hasItems, mutateAsync, items, onChange]);

    const menu = (
      <Menu onClick={handleChange}>
        {
          map(PROPOSAL_STATUS_ENUM, (status) => statusFilter[status] ? (
            <Menu.Item key={status}>
              <ProposalRequestStatus status={status} full help/>
            </Menu.Item>
          ) : '')
        }
      </Menu>
    );

    return (
      <Dropdown overlay={menu} trigger={['click']}>
        <Button loading={isLoading} type="link" disabled={isLoading || !hasItems}
          icon={<ControlOutlined/>}>{t('proposalRequest.changeStatus')}</Button>
      </Dropdown>
    );

  };

  UpdateStatusManyButton.propTypes = {
    onChange: PropTypes.func,
    items: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
  };

  return memo(UpdateStatusManyButton);
};
